import { authApi } from '@/api'

export const login = (params: any) => {
  return authApi.post('api/v1/metax/login', params)
}

export const sendSms = (params: any) => {
  return authApi.post('api/v1/metax/send_sms', params)
}
